import {
    CLEAR_MESSAGE, CLEAR_REQUEST,
    MESSAGE_IS_PENDING,
    REQUEST_FAILED, REQUEST_SEND,
    SEND_MESSAGE,
    SEND_MESSAGE_FAIL
} from "../actions/actionTypes";

const initialState = {
    status : 0,
    message: "",
    isPending:false,
    isFailed :null
}

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case MESSAGE_IS_PENDING:
            return {
                ...state,
                isPending: true
            }

        case SEND_MESSAGE:
            return {
                status : action.payload.status,
                message: action.payload.message,
                isPending: false
            }
        case SEND_MESSAGE_FAIL: {
            return {
                status : action.payload.status,
                message: action.payload.message,
                isPending: false
            }
        }
        case CLEAR_MESSAGE:
            return {
                message: "",
                status : 0,
                isPending: false
            }

        case REQUEST_SEND :
            return{
                ...state,
                isFailed: false
            }
        case REQUEST_FAILED :

            return{
                ...state,
                isFailed: true
            }
        case CLEAR_REQUEST :
            return{
                ...state,
                isFailed: null
            }

        default:
            return state
    }
}

export default messageReducer;